<template>
    <div class="">
        <button class="btn btn-info" @click="abrirModal()">Agregar</button>
        <vuestic-modal :show.sync="show" v-bind:large="true" ref="largeModal">
            <form @submit.prevent="">
                <div class="form-group">
                    <div class="input-group">
                        <label for="fecha">Fecha</label>
                        <input required="required" id="fecha" type="date">
                        <i class="bar"></i>
                    </div>
                    <div class="input-group">
                        <label for="folio">Folio</label>
                        <input required="required" id="folio" type="text">
                        <i class="bar"></i>
                    </div>
                    <div class="input-group">
                        <label for="tipoDocumento">Tipo Documento</label>
                        <select id="tipoDocumento" required="required">
                            <option value="">Seleccione...</option>
                            <option value="1">Factura</option>
                            <option value="2">Guia</option>
                        </select>
                        <i class="bar"></i>
                    </div>
                    <div class="input-group">
                        <label for="proveedores">Proveedores</label>
                        <vuestic-simple-select
                            v-model="proveedores"
                            id="proveedores"
                            :options="proveedor"
                            option-key="nombre"
                        ></vuestic-simple-select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group">
                        <label for="transportes">Transporte</label>
                        <select name="" id="transportes">
                            <option value="">Seleccione...</option>
                            <option v-for="dato in transportes" value="">{{dato.nombre}}</option>
                        </select>
                        <i class="bar"></i>
                    </div>
                    <div class="input-group">
                        <label for="oT">O/T</label>
                        <input id="oT" type="text" required="required">
                        <i class="bar"></i>
                    </div>
                    <div class="input-group">
                        <label for="bultos">Bultos</label>
                        <input id="bultos" type="number" required="required">
                        <i class="bar"></i>
                    </div>
                    <div class="input-group">
                        <label for="flete">Flete</label>
                        <input id="flete" type="text" required="required">
                        <i class="bar"></i>
                    </div>
                </div>
            </form>
        </vuestic-modal>
    </div>
</template>

<script>
  import VuesticModal from '../../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal'
  import Proveedor from '../../../compra/component/selectCompras/Proveedor'
  import Transporte from '../../../compra/component/selectCompras/Transporte'
  import VuesticSimpleSelect
      from "../../../../vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect";
  export default {
    name: 'Btn',
    components: {VuesticSimpleSelect, Transporte, Proveedor, VuesticModal },
    data(){
      return{
          show:true,
          modelProveedor:'',
          modelTransporte:''
      }
    },
    methods:{
      abrirModal(){
        this.$refs.largeModal.open()
      }
    },
    created() {
        this.$store.dispatch('loadTransporte')
        console.log(this.$store.dispatch('loadProveedores'))
    },
    computed:{
        transportes(){
            return this.$store.getters.transportes
        },
        proveedor(){
            return this.$store.getters.proveedores
        }
    }
  }
</script>

<style scoped>
    label{
        font-weight: bold;
    }
    .input-group{
        width: 20%;
        margin: 30px;
    }
    .btn{
        margin-bottom: 30px;
    }
    select{
        cursor: pointer;
    }
</style>
